import { View } from 'es6/components/view'
import 'es6/libs/owl-carousel'

/**
 * Вид секции с лицензионной продукцией.
 * @param {string}  el       Элемент вида
 * @param {boolean} isMobile Признак отображения с мобильных устройств
 * @constructor
 */
export class LicenceGoodsView extends View {
  /** @inheritDoc */
  run (options) {
    this.isMobile = options.isMobile
    if (!this.isMobile) {
      this.$('.js-carousel').owlCarousel({
        loop: false,
        nav: true,
        mouseDrag: false,
        dots: false,
        responsiveClass: true,
        autoplay: false,
        margin: 32,
        responsive: {
          0: {
            items: 6,
            slideBy: 6,
          },
          1440: {
            items: 5,
            slideBy: 5,
          },
        },
      })
    }
  }
}
